import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import Categories from '../components/categories/categories'
import '../styles/common.css'
import '../styles/index.scss'

const Layout = ({ children, location, data }) => {
  let pageName =
    location.pathname.split('/')[1] === ''
      ? 'home'
      : location.pathname.split('/')[1].split('.')[0]
  const currentPage = 'p-' + pageName

  return (
    <div>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          {
            name: 'description',
            content:
              'HCV Handbook is a comprehensive mini encyclopedia for all related informnation about Hepatitis C Virus; 丙型肝炎手册是一本关于 C 型肝炎病毒及其相关信息的迷你小百科',
          },
          {
            name: 'keywords',
            content:
              'Hepatitis C Virus, HCV, Hepatitis, Hepatitis C, virus, inflammation, cirrhosis, transfusion, snort, hemodialysis, tattoo, fatigue, fever, early stages, acute, chronic, antibody, PCR, biopsy, ultrasound, MRI, antibody, Interferons, DAA, genotype, transplant, cancer, ascites, Pressure, Bleeding, Toxins, diet, never share needles, safe sex, hand hygiene, disease education, regular monitoring',
          },
        ]}
      />
      <Header page={currentPage} siteInfo={data.site.siteMetadata} />
      <div className="content">{children()}</div>
      <Categories page={currentPage} />
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.object,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        description
        manifesto
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js